import { GLServiceBase, ServiceRoute } from "commonui";
import {
	ITextAnalysis,
	RWTextAnalysisReportRequestModel,
	RWTextAnalysisResponseModel,
	RWTextAnalysisSeriesChapterModel,
	TextAnalysisReportRequestModel
} from ".";

class TextAnalysisClass extends GLServiceBase<any, any> implements ITextAnalysis {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcsReports" };

	getTextAnalysisReport(query: TextAnalysisReportRequestModel): Promise<any> {
		return this.get("textAnalysis", query);
	}

	getRWTextAnalysisSeriesChapter(grapeseedVersion: string): Promise<RWTextAnalysisSeriesChapterModel[]> {
		return this.get("rwTextAnalysisSeriesChapter", { grapeseedVersion });
	}
	getRWTextAnalysisReport(query: RWTextAnalysisReportRequestModel): Promise<RWTextAnalysisResponseModel> {
		return this.get("rwTextAnalysis", query);
	}
}

export const TextAnalysisService: ITextAnalysis = new TextAnalysisClass() as ITextAnalysis;
